export enum PriceType {
  TotalPrice = 'totalPrice',
  DiscountedAmount = 'discountedAmount',
  CrossedOutPrice = 'crossedOutPrice',
  unitPrice = 'unitPrice',
  unitCrossedOutPrice = 'unitCrossedOutPrice',
  OfferCode = 'offerCode',
}

export enum PriceSourceType {
  Converted = 'converted',
  Original = 'original',
}

export enum TaxType {
  Included = 'included',
  excluded = 'excluded',
  onSite = 'onSite',
}

export interface Money {
  amount: number;
  currency: string;
}

export interface MoneyPrice {
  value: Money;
  text: string;
}

export interface OfferCode {
  code?: string;
  description?: string;
}

export interface MoneyTax {
  amount: MoneyPrice;
  details: Array<{
    amount: PriceSource,
    applyToEntity: boolean,
    description: string,
    name: string,
  }>;
}

export type Price = {
  totalPrice: PriceSource; // TODO check if always present
  discountedAmount?: PriceSource;
  crossedOutPrice?: PriceSource;
  unitPrice?: PriceSource;
  unitCrossedOutPrice?: PriceSource;
  offerCode?: OfferCode;
};

export type PriceSource = {
  [P in PriceSourceType]: MoneyPrice;
};

export type Tax = {
  [P in TaxType]: MoneyTax;
};

export type TaxBasket = {
  [P in TaxType]: MoneyPrice;
};
